import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import BlacksmithWorkshop from '../components/BlacksmithWorkshop';
import { Principal } from '@dfinity/principal';
import { getAllLimitedEditionNFTs } from '../services/limited_edition_service';
import { useAuth } from '../auth/useAuth';

export default function LimitedEditionPage() {
  const { agent } = useAuth();
  const [nfts, setNfts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadNFTs();
  }, [agent]);

  const loadNFTs = async () => {
    setLoading(true);
    try {
      // Call limited_edition canister's get_all_limited_edition_nfts
      if (!agent) throw new Error('Agent not ready');
      const nfts = await getAllLimitedEditionNFTs(agent);
      setNfts(nfts);
    } catch (err: any) {
      console.error('Failed to load NFTs:', err);
      setError(err.message || 'Failed to load NFTs. Please ensure canister is deployed.');
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  const getExplorerLink = (canisterId: string) => {
    return `https://dashboard.internetcomputer.org/canister/${canisterId}`;
  };

  return (
    <BlacksmithWorkshop>
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="glass-dark rounded-2xl p-8 mb-6">
            <h1 className="text-4xl font-bold mb-6 text-gold">Limited Edition Anvil NFTs</h1>
            
            {loading ? (
              <p className="text-gray-300">Loading NFTs...</p>
            ) : error ? (
              <p className="text-red-400">{error}</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {nfts.map((nft) => (
                  <div
                    key={nft.nft_number}
                    className="glass rounded-lg p-4 border border-gray-600"
                  >
                    <h3 className="text-lg font-semibold mb-2 text-gold">
                      {nft.metadata.name}
                    </h3>
                    
                    <div className="space-y-2 text-sm">
                      <div>
                        <p className="text-gray-400">Canister ID:</p>
                        <p className="font-mono text-xs break-all text-gray-300">
                          {nft.canister_id}
                        </p>
                        <button
                          onClick={() => copyToClipboard(nft.canister_id)}
                          className="text-xs text-gold hover:underline mt-1"
                        >
                          Copy
                        </button>
                      </div>
                      
                      <div>
                        <p className="text-gray-400">Discount Code:</p>
                        <p className="font-mono text-xs text-gray-300">
                          {nft.discount_code}
                        </p>
                        <button
                          onClick={() => copyToClipboard(nft.discount_code)}
                          className="text-xs text-gold hover:underline mt-1"
                        >
                          Copy
                        </button>
                      </div>
                      
                      <div>
                        <p className="text-gray-400">Status:</p>
                        <p className={`text-xs ${
                          nft.status === 'active' ? 'text-green-400' :
                          nft.status === 'burned' ? 'text-red-400' :
                          'text-gray-400'
                        }`}>
                          {nft.status.toUpperCase()}
                        </p>
                      </div>
                      
                      <a
                        href={getExplorerLink(nft.canister_id)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block text-xs text-blue-400 hover:underline mt-2"
                      >
                        View on Explorer →
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </BlacksmithWorkshop>
  );
}

